import { createApiCall } from 'lib/base';

export interface AdminAccount {
  id: number;
  name: string;
  email: string;
  role: string;
  has_password: boolean;
  two_factor_enabled: boolean;
  // The role (admin/superadmin) must use 2FA; it can't be turned off.
  two_factor_required: boolean;
  backup_codes_left: number;
}

const FETCH_ADMIN_ACCOUNT = 'FETCH_ADMIN_ACCOUNT';

export const getAdminAccountApi = createApiCall(FETCH_ADMIN_ACCOUNT, () => ({
  endpoint: `api/admin/account`,
  method: 'GET',
}));

export default getAdminAccountApi;
